const DietDeductionTypes = {
    Breakfast: 1,
    Lunch: 2,
    Dinner: 3
};

Object.freeze(DietDeductionTypes);

export default DietDeductionTypes;